import { render, staticRenderFns } from "./PlanningPeopleModal.vue?vue&type=template&id=656a278e"
import script from "./PlanningPeopleModal.vue?vue&type=script&lang=js"
export * from "./PlanningPeopleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports